module.exports = __webpack_public_path__ + "img/7.a7be7bd7.jpg";